import React, { useEffect, useContext } from 'react'
import 'react-credit-cards/es/styles-compiled.css'
import FlexView from 'react-flexview/lib'
import { isInFlow } from '../../../services/utils'
import { UserApi } from '../../../api/user.api'
import { BrowserView, MobileView } from 'react-device-detect'
import { useLocation } from 'react-router-dom'
import { BackButton } from '../../Core/Buttons/BackButton'
import { BottomSheetPolicySummary } from '../../Insurance/BottomSheetPolicySummary'
import NewFillButton from '../../Core/NewFillButton'
import { RectangleFrame } from '../../Core/Frames/RectangleFrame'
import { Grid } from '@material-ui/core'
import { BuyingInsuranceContextStore } from '../../../context/BuyingInsuranceContext'
import { SessionContextStore } from '../../../context/SessionContext'

const WalletPayment = ({ onPurchase, paymentRequest }) => {
  const location = useLocation()
  const { paymentMethod } = useContext(BuyingInsuranceContextStore)
  const { newPaymentFlow } = useContext(SessionContextStore)
  // useEffect(() => {
  //   if (!paymentRequest) return;
  //   console.log(paymentRequest);
  //   paymentRequest.on("paymentmethod", async (e) => {
  //     let response = await UserApi.attachPaymentMethod(e.paymentMethod.id);
  //     if (response.ok) {
  //       e.complete('success');
  //       onPurchase();
  //       return;
  //     }
  //     e.complete('fail');
  //   });
  // }, [paymentRequest]);

  return (
    <>
      <Grid container className="margin-top-basic margin-bottom-basic">
        <RectangleFrame
          color="purple"
          className="no-margins-sides"
        >{`Click on the ${paymentMethod} button to complete today’s payment or choose a different payment option`}</RectangleFrame>
      </Grid>
      {/* <MobileView>
                {isInFlow(location.pathname) && 
                    <BottomSheetPolicySummary title={'Purchase'} onClick={() => {
                      paymentRequest.show();
                    }} /> }
      </MobileView> */}
      <MobileView>
        {isInFlow(location.pathname) && !newPaymentFlow && <BottomSheetPolicySummary shouldShowButton={false} title={'Purchase'} />}
      </MobileView>
    </>
  )
}

export default WalletPayment
